export class Floor {
  id: string;
  totalNumberOfUnits: number = 0;
  floorNumber: number;

  constructor(obj: Partial<Floor>) {
    Object.assign(this, obj);
  }
}
